import { createContext } from 'react';

const ComboboxTextFieldContext = /*#__PURE__*/createContext(undefined);
const ComboboxListboxContext = /*#__PURE__*/createContext({});
const ComboboxListboxOptionContext = /*#__PURE__*/createContext({});

export { ComboboxListboxContext, ComboboxListboxOptionContext, ComboboxTextFieldContext };
